import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons, DeleteConfirmationModal } from "@components";
import { RewardForm } from "./RewardForm";

import { rewardValidation } from "@validations/HRM/employee/qualificationsValidation";

import { RewardType } from "@type/HRM/qualification";

interface RewardPropsType {
  rewardInfo: RewardType;
  changeRewardsInfo: (data: RewardType) => void;
  removeRewardInfo: (rewardID: number) => void;
  getQualificationInfoRequestOngoing: boolean;
  updateRewardRequestOngoing: boolean;
  deleteRewardRequestOngoing: boolean;
}

export const Reward = ({
  rewardInfo,
  changeRewardsInfo,
  removeRewardInfo,
  getQualificationInfoRequestOngoing,
  updateRewardRequestOngoing,
  deleteRewardRequestOngoing,
}: RewardPropsType) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    closeConfirmationModal();
    removeRewardInfo(rewardInfo.id);
  };

  const methods = useForm<RewardType>({
    resolver: yupResolver(rewardValidation),
    values: rewardInfo as RewardType,
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<RewardType> = (data: RewardType) => {
    changeRewardsInfo(data);
  };

  let isSaving =
    getQualificationInfoRequestOngoing || updateRewardRequestOngoing;
  let isDeleting =
    getQualificationInfoRequestOngoing || deleteRewardRequestOngoing;

  return (
    <>
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          action={deleteAction}
          onClose={closeConfirmationModal}
        />
      )}
      <FormProvider {...methods}>
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <RewardForm />
          <ActionButtons
            isSaving={isSaving}
            isDeleting={isDeleting}
            deleteAction={() => setIsConfirmationModalOpen(true)}
          />
        </form>
      </FormProvider>
    </>
  );
};
